import React from "react";
import { MessageCircle } from "lucide-react";

/**
 * Floating WhatsApp button.
 * Reads REACT_APP_WHATSAPP_NUMBER (E.164 format without + sign, e.g. "41791234567").
 * If the env var is empty, the button is hidden.
 */
export default function WhatsAppButton({
  message = "Hallo Solanova, ich interessiere mich für eine Solaranlage.",
}) {
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
  if (!number) return null;

  const href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Per WhatsApp kontaktieren"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] blur-xl opacity-50 group-hover:opacity-80 transition-opacity" />
      <span className="relative flex items-center gap-3 bg-[#25D366] text-white py-3.5 pl-4 pr-5 rounded-full shadow-[0_10px_40px_-10px_rgba(37,211,102,0.6)] hover:scale-[1.03] transition-transform">
        <MessageCircle size={22} strokeWidth={2} />
        <span className="hidden sm:inline text-sm font-medium font-body">WhatsApp</span>
      </span>
    </a>
  );
}
